import {mergeProperties, reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums"

export const getFormData = (data) => {
    const initialData = {
        template: '',
        restaurant: '',
        branch: ''
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};


export const getTableColumns = ({ActionDropdown}) => {
    let tableColumns = [
        {header: "Plan", field: "template"},
        {header: "Branch", field: "branch"},
        {header: "Restaurant", field: "restaurant"},
        {header: "Expiry Date", field: "billingDate"},
        {header: "Status", field: "status"},
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} edit={false}/>;
        },
    });

    return tableColumns;
};


export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        template: item.template?.name,
        branch: item.branch?.name,
        restaurant: item.branch?.restaurant?.name,
        billingDate: item.nextBillingDate,
        status: reverseEnum(Status)[item.status]
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};

    return {
        details: {
            template: item.template?.name,
            branch: item.branch?.name,
            restaurant: item.branch?.restaurant?.name,
            price: item.price,
            startDate: item.startDate,
            expiryDate: item.nextBillingDate,
            lastPaymentDate: item.lastPaymentDate,
            status: reverseEnum(Status)[item.status],
        }
    };
}
